import { css } from 'styled-components';

const CalendarHeader = {
  DropdownWrapper: css` `,
  Header: css` `,
  WeeksCounterText: css` `,
  NavigationButton: css` `,
  Padding: css` `,
  CalendarNavigator: css` `,
  CurrentDate: css`
  color: #4A4A4A;
  `,
  Wrapper: css` `,
  ActionButtons: css` `,
  SymbologyTitle: css` `,
  SymbologyList: css` `,
  HelperButton: css` `,
  TooltipItem: css` `,
  SymbolHeader: css` `,
  CloseIcon: css` `,
};

export default CalendarHeader;
